// 手写弹窗可达性基线指令：焦点圈禁、Esc 关闭、关闭后归还焦点。
// 依赖 v-if 的挂载/卸载即弹窗开关生命周期；嵌套弹窗通过模块级栈保证只有最顶层响应。
// 用法：<div v-if="showX" role="dialog" aria-modal="true" v-modal-a11y="closeX">（或内联箭头函数）

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ')

const stack = []
let listenerAttached = false

function getFocusable(el) {
  return Array.from(el.querySelectorAll(FOCUSABLE_SELECTOR))
    .filter(node => node.offsetParent !== null || node === document.activeElement)
}

function trapTab(event, el) {
  const focusable = getFocusable(el)
  if (focusable.length === 0) {
    event.preventDefault()
    el.focus()
    return
  }
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  const activeOutside = !el.contains(document.activeElement)
  if (event.shiftKey && (document.activeElement === first || activeOutside)) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && (document.activeElement === last || activeOutside)) {
    event.preventDefault()
    first.focus()
  }
}

function onKeydown(event) {
  const top = stack[stack.length - 1]
  if (!top) return
  if (event.key === 'Escape') {
    event.stopPropagation()
    top.close?.()
    return
  }
  if (event.key === 'Tab') {
    trapTab(event, top.el)
  }
}

function attachListener() {
  if (!listenerAttached) {
    document.addEventListener('keydown', onKeydown, true)
    listenerAttached = true
  }
}

function detachListenerIfIdle() {
  if (listenerAttached && stack.length === 0) {
    document.removeEventListener('keydown', onKeydown, true)
    listenerAttached = false
  }
}

export default {
  mounted(el, binding) {
    const entry = {
      el,
      close: typeof binding.value === 'function' ? binding.value : null,
      previousFocus: document.activeElement
    }
    stack.push(entry)
    attachListener()

    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '-1')
    }
    const target = getFocusable(el)[0] || el
    target.focus()
  },
  unmounted(el) {
    const index = stack.findIndex(entry => entry.el === el)
    if (index === -1) return
    const [entry] = stack.splice(index, 1)
    detachListenerIfIdle()

    const { previousFocus } = entry
    if (previousFocus && document.contains(previousFocus)) {
      previousFocus.focus()
    }
  }
}
